import { PERMS } from '@/config/permissions';
import DefaultLayout from '@/layouts/DefaultLayout.vue';

const TaskAssign = () => import('@/modules/task/assign/TaskAssign.vue');
const TaskMonitor = () => import('@/modules/task/monitor/TaskMonitor.vue');
const TaskException = () => import('@/modules/task/exception/TaskException.vue');
const TaskReminderConfig = () => import('@/modules/task/TaskReminderConfig.vue');

export const taskRoutes = {
  path: '/task',
  name: 'Task',
  component: DefaultLayout,
  meta: {
    title: '任务管理',
    titleKey: 'route.task',
    icon: 'Histogram',
    order: 3,
  },
  children: [
    {
      path: 'assign',
      name: 'TaskAssign',
      component: TaskAssign,
      meta: {
        title: '任务模板',
        titleKey: 'route.taskAssign',
        icon: 'deployment-unit',
        order: 30,
        permissions: [PERMS.TASK_TEMPLATE_VIEW],
      },
    },
    {
      path: 'monitor',
      name: 'TaskMonitor',
      component: TaskMonitor,
      meta: {
        title: '任务监控',
        titleKey: 'route.taskMonitor',
        icon: 'dashboard',
        order: 31,
        permissions: [PERMS.TASK_MONITOR_VIEW],
      },
    },
    {
      path: 'exception',
      name: 'TaskException',
      component: TaskException,
      meta: {
        title: '异常处理',
        titleKey: 'route.taskException',
        icon: 'warning',
        order: 32,
        permissions: [PERMS.TASK_EXCEPTION_VIEW],
      },
    },
    {
      path: 'reminder-config',
      name: 'TaskReminderConfig',
      component: TaskReminderConfig,
      meta: {
        title: '定时提醒',
        titleKey: 'route.taskReminderConfig',
        icon: 'alarm-clock',
        order: 33,
        permissions: [PERMS.TASK_REMINDER_CONFIG_VIEW],
      },
    },
  ],
};
